import { render, staticRenderFns } from "./CreateTariffPackagesModal.vue?vue&type=template&id=3b92309e&scoped=true&"
import script from "./CreateTariffPackagesModal.vue?vue&type=script&lang=js&"
export * from "./CreateTariffPackagesModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTariffPackagesModal.vue?vue&type=style&index=0&id=3b92309e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92309e",
  null
  
)

export default component.exports